


/* BEGIN KTW JS for Variant Product Code, MOQ and Availability */
//const targetNode = document.querySelector('#Sku-template--20978025103429__main');
//const targetNode = document.querySelector('Sku-template--20978025103429__main');
//let previousContent = targetNode.textContent;
var targetNode = document.getElementById('Sku-template--20978025103429__main');
if(targetNode == null) {
  targetNode = document.getElementById('Sku-quickadd-template--20978025103429__main');
}

let previousContent = targetNode.textContent;
onTextChange(previousContent);

setInterval(() => {
  checkForSKUChange();
}, 500); // Check every 500ms

function checkForSKUChange() {
  const currentContent = targetNode.textContent;
  if (currentContent !== previousContent) {
    console.log('Text content changed!');
    onTextChange(currentContent);
    previousContent = currentContent;
  }
}

function onTextChange(productCodeTextString) {
  var productCodeTextArray = productCodeTextString.split(":");
  var variantSKU = productCodeTextArray[0];
  if(productCodeTextArray.length>1) {
    variantSKU = productCodeTextArray[1];
  }
  console.log('New text:', variantSKU);
  updateMOQandAvailability(variantSKU);
}

function updateMOQandAvailability(variantSKU) {
  var skuList = document.getElementById("sku-list").innerHTML;
  var moqList = document.getElementById("moq-list").innerHTML;
  var inventoryList = document.getElementById("inventory-list").innerHTML;
  var inventoryManagementList = document.getElementById("inventory-management-list").innerHTML;
  var inventoryPolicyList = document.getElementById("inventory-policy-list").innerHTML;
  var skuArray = new Array();
  var moqArray = new Array();
  var inventoryArray = new Array();
  var inventoryManagementArray = new Array();
  var inventoryPolicyArray = new Array();
  skuArray = skuList.split(",");
  moqArray = moqList.split(",");
  inventoryArray = inventoryList.split(",");
  inventoryManagementArray = inventoryManagementList.split(",");
  inventoryPolicyArray = inventoryPolicyList.split(",");
  var iMax = skuArray.length;
  for(var i=0;i<iMax;i++) {
    if(variantSKU == skuArray[i]) {
      var myMOQ = moqArray[i];
      var myInventoryQty = eval(inventoryArray[i]);
      if(myMOQ == '') {
        if(myInventoryQty > 0){
          myMOQ = "1";
        } else {
          myMOQ = "0";
        }
      }
      if(myInventoryQty == 0) {
        myMOQ = "0";
      }     
      if((inventoryManagementArray[i] == "shopify") && (inventoryPolicyArray[i] == "continue")) {
        if(myMOQ == "0") {
          myMOQ = "1";
        }
      }
      document.getElementById("variantmoq").innerHTML = myMOQ;
      //document.getElementById("MOQ").innerHTML = moqArray[i];
      
      if((inventoryManagementArray[i] == "shopify") && (inventoryPolicyArray[i] == "deny")) {
        if(myInventoryQty < 1) {
          document.getElementById("variant-inventory").innerHTML = "No";
        } else {
          document.getElementById("variant-inventory").innerHTML = myInventoryQty;
        }
      } else if((inventoryManagementArray[i] == "shopify") && (inventoryPolicyArray[i] == "continue")) {
        if(myInventoryQty < 1) {
          document.getElementById("variant-inventory").innerHTML = "Yes";
        } else {
          document.getElementById("variant-inventory").innerHTML = myInventoryQty;
        }
      }
      break;
    }
  }
}

/* END KTW JS for Variant Product Code, MOQ and Availability */




/* BEGIN KTW JS for Product Form Text Input Field to auto-transform text to ALL CAPS when input field loses focus */
/* Note: this JS is used in conjunction with custom KTW CSS for displaying text in ALL CAPS as the user types. */
/* The JS here ensures the text submitted to the server is in ALL CAPS too. */

//const targetNode2 = document.querySelector('div.text-input-all-caps span input.spb-productdescfont');
/*
targetNode2.addEventListener("blur", myBlurFunction);
function myBlurFunction() {
	targetNode2.onblur="this.value = this.value.toUpperCase();
}
*/

//document.getElementById("Enter Individual Name-0-0")
const targetNode3 = document.querySelector('button.product-form__submit');
targetNode3.addEventListener("focus", onFocusAddToCart);

function onFocusAddToCart() {
  const targetNode2 = document.querySelector('div.text-input-all-caps span input.spb-productdescfont');
  var tempValue = targetNode2.value;
  tempValue = tempValue.toUpperCase();
  targetNode2.value = tempValue;
  //setTimeout(myFunction, 3000);
}

/*
function changeTextToAllCaps() {

}
*/

/* END KTW JS for Product Form Text Input Field to auto-transform text to ALL CAPS when input field loses focus */